import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './metric-comparison-step3.hbs'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'

const defaultColumnDataByColumnType = {
	'calendar-id': {
		customLabel: true,
		label: 'report.customReport.nativeCalendar'
	},
	'goal': {
		abbreviated: true,
		customLabel: true,
		label: 'scorecards.node.metric.threshold.goal',
		colorType: 'regular'
	}
}

var PeriodsView = Backbone.View.extend({

	className: 'report-metric-comparison metric-comparison-step3',

	events: {
		'change input[type=checkbox]': 'checkboxChange'
	},

	initialize: function(options = {}) {
		this.options = options
		this.rangeSelector = new CalendarRangeSelector(
			_.defaults({canChangeCalendar: true, singlePeriod: true}, this.model.attributes))

		if (!this.model.has('range')) {
			this.model.set('range', this.rangeSelector.val())
		}
		//the second stack holds the breakdown
		this.repeatByStack = this.model.stacks(1)

		let breakdowns = this.repeatByStack.get('repeatBy').get('breakdowns')
		//keep a reference of the breakdown model and period because they can be changed
		this.breakdownWithPeriod = breakdowns[0]
		this.breakdownWithColumn = breakdowns[1]

		//apply selector changes to model
		this.listenTo(this.rangeSelector, 'change', () => {
			this.breakdownWithPeriod.set('range', this.rangeSelector.val())
		})
	},

	_labelColumn: function() {
		return this.model.stacks(0).columns(0)
	},

	checkboxChange: function(e) {
		var checkbox = $(e.target)
		let enable = checkbox.prop('checked')
		let property = checkbox.attr('name')
		if (property == 'showAbbreviatedValues') {
			this._onChangeShowAbbreviatedValues(e)
		} else if (property == 'invert') {
			let labelColumn = this._labelColumn()
			let groupingId = labelColumn.get('groupingId')
			let breakdownColumnType = 'organization'
			let labelAttributes = this.model._defaultColumnData('label', {groupingId})
			if (enable) {
				breakdownColumnType = 'label'
				labelAttributes = this.model._defaultColumnData('organization', {groupingId})
			}
			this.breakdownWithColumn.set('breakdownBy', breakdownColumnType, {silent: true})
			labelColumn.set(labelAttributes, {silent: true})
		} else {
			this._toggleColumn(property, enable)
		}
	},

	_toggleColumn: function(columnType, show) {
		if (show) {
			this.model.addColumnToRepeatBy(0, this.repeatByStack, columnType, {
				silent: true,
				columnData : _.extend({}, defaultColumnDataByColumnType[columnType], {
					abbreviated: !!this.$('[name=showAbbreviatedValues]').prop('checked')
				})
			})
		} else {
			_.each(this.repeatByStack.findColumnsByFieldIdOrColumnType(columnType), column => {
				column.destroy({silent: true})
			})
		}
	},

	_onChangeShowAbbreviatedValues(e) {
		let enable = !!$(e.target).prop('checked')
		this.model.setAbbreviateValues(enable)
	},

	render: function() {
		this.$el.html(template(_.extend({
			invert: this._labelColumn().get('columnType') === 'organization'
		}, this.model.attributes)))
		this.rangeSelector.setElement(this.$('.toggler-rows')).render()
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.rangeSelector], 'remove')
	}
})

export default PeriodsView

PeriodsView.__filename__ = 'reports/wizard/metric-comparison/metric-comparison-step3.js'
